import React from 'react';
export function TrustBar() {
  const partners = ['NATIONAL TPA', 'CARRIER CO.', 'ENTERPRISE RISK', 'WORKERS COMP MGT', 'PUBLIC ENTITY PARTNERS'];
  return <section className="bg-white border-b border-gray-200 py-8" data-id="element-330" data-mp="y8zbjq11cjvy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-331" data-mp="yak3r8zvnqqn">
        <p className="text-center text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6" data-id="element-332" data-mp="138vh3tpdsjdm">
          Trusted by leading carriers, TPAs, and employers nationwide
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale" data-id="element-333" data-mp="1uzhzatfgbsov">
          {partners.map((partner, index) => <div key={index} className="text-xl md:text-2xl font-serif font-bold text-gray-400 tracking-tight" data-id="element-334" data-mp="1h1bae2shd31c" data-mpi={index}>
              {partner}
            </div>)}
        </div>
      </div>
    </section>;
}